import * as React from "react";
import Notification from "antd/lib/notification";
import { ReactComponent as Icon } from "../Assets/images/download.svg";
import ServiceReport from "../Services/ServiceReport";
import Message from "antd/lib/message";
import Popover from "antd/lib/popover";
import "./Download.scss";
import { Producer } from "../Models/Report";
import Menu from "antd/lib/menu";
import Button from 'antd/lib/button';

export interface IDownloadProps {
	producers: Producer[];
	idUser: number;
}

let isDownload = false;
const Download = (props: IDownloadProps) => {
	const onDownload = (idProducer: string) => {
		if (isDownload) {
			Notification.warning({
				description: "Existe un descarga en curso",
				message: "Notificación"
			});
			return;
		}
		const cancel = Message.loading(
			"Espere unos minutos estamos generando el Excel",
			0
		);
		const service = new ServiceReport();
		isDownload = true;
		service
			.downloadExcel(props.idUser, idProducer)
			.then(blob => {
				if (!blob) {
					Notification.error({
						description: "Error descargando archivo",
						message: "Archivo Excel"
					});
					return;
				}
				isDownload = false;
				cancel();
				var url = URL.createObjectURL(blob);
				var a = document.createElement("a");
				a.href = url;
				a.download = "data.xlsx";
				document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
				a.click();
				a.remove(); //afterwards we remove the element again
				Notification.success({
					description: "Documento Generado Exitosamente",
					message: "Archivo Excel"
				});
			})
			.catch(e => {
				isDownload = false;
				Notification.error({
					description: e,
					message: "Archivo Excel"
				});
			});
	};
	if (props.producers.length > 1) {
		const content = (
			<div className="Download-Options">
				{props.producers.map(p => <Button type="link" key={`download-${p.id}`} onClick={() => onDownload(p.id)}>{p.name}</Button>)}
			</div>
		);
		return (
			<Popover overlayClassName="Download-Box" content={content} title="Seleccione Empresa" trigger="click">
				<div className="Download">
					<div className="Download-Text">Descargar Excel</div>
					<div className="Download-Icon">
						<Icon />
					</div>
				</div>
			</Popover>
		);
	}
	return (
		<div className="Download" onClick={() => onDownload(props.producers[0].id)}>
			<div className="Download-Text">Descargar Excel</div>
			<div className="Download-Icon">
				<Icon />
			</div>
		</div>
	);
};

export default Download;
